import * as React from 'react'
import { CarouselCollection } from '../carousel/carouselCollection'
import { ICollection } from '../../selectors/collections'
import { CollectionDetail } from '../../reducers/collections'
import * as st from './bundleCarousel.module.scss'

export const BundleCarousel = (bundleCarouselCollection: CollectionDetail) => {
  const collectionProps = {
    header: bundleCarouselCollection.header,
    collectionType: bundleCarouselCollection.collectionType,
    cardTitleIds: bundleCarouselCollection.titleIds,
    totalEpisodeSize: bundleCarouselCollection.totalCardSize,
    refTagPrefix: 'atv_dp_bundle_',
  } as ICollection
  const shouldRender = collectionProps.cardTitleIds && collectionProps.cardTitleIds.length > 0

  return shouldRender ? (
    <div className={st.avDpBundleCarousel}>
      <CarouselCollection {...collectionProps} />
    </div>
  ) : null
}